/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Subscription
 * @author      Deniss Strombergs <info@scandiweb.com>
 */

import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/Subscription/Query */
export class SubscriptionQuery {
    getSubscriptionEmailQuery(email) {
        return new Field('addEmailToSubscription')
            .addArgument('email', 'String!', email);
    }

    getEmarsysUnsubscribeQuery(hash, uid, cid, llid) {
        return new Field('EmarsysUnsubscribe')
            .addArgument('hash', 'String!', hash)
            .addArgument('uid', 'String!', uid)
            .addArgument('cid', 'String!', cid)
            .addArgument('llid', 'String!', llid);
    }

    getSubscriptionGenderBirthdayQueary(email, gender, dob) {
        return new Field('addGenderBirthdateToSubscription')
            .addArgument('email', 'String!', email)
            .addArgument('gender', 'Int!', gender)
            .addArgument('dob', 'String', dob);
    }

    getSubscriptionCmsQuery(email, first_name, last_name, emarsys_source_code, gender, dob) {
        return new Field('cmsContentSubscription')
            .addArgument('email', 'String!', email)
            .addArgument('first_name', 'String!', first_name)
            .addArgument('last_name', 'String!', last_name)
            .addArgument('emarsys_source_code', 'String!', emarsys_source_code)
            .addArgument('gender', 'Int!', gender)
            .addArgument('dob', 'String', dob);
    }
}

export default new SubscriptionQuery();
